import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gap: 20,
    gridTemplateColumns: '1fr 1fr 1fr',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 16
  },
  hide: {
    opacity: 0
  },
  greenColor: {
    color: theme.palette.secondary.main
  },
  redColor: {
    color: theme.palette.primary.main
  },
  greyColor: {
    color: theme.palette.grey[400]
  }
}))
export default useStyles
